/* My Kid's Dream - live book preview, part 4: open-book view engine.
 * Bitmap cache + background warming for instant turns; staged 3D page flip:
 * the revealed side changes under the turning sheet, the other side waits
 * until the sheet lands, exactly like a real book. */
window.MKDP = window.MKDP || {};
MKDP.state.bitmaps = {};
MKDP.state.bitmapOrder = [];
MKDP.state.cacheEpoch = 0;
MKDP.state.animating = false;
MKDP.clearBitmaps = function () {
  MKDP.state.bitmaps = {};
  MKDP.state.bitmapOrder = [];
  MKDP.state.cacheEpoch++;
};
MKDP.leftOf = function (page) {
  if (page <= 1) return 1;
  return page % 2 === 0 ? page : page - 1;
};
MKDP.viewPages = function () {
  return MKDP.pagesFor(MKDP.state.page);
};
MKDP.pagesFor = function (page) {
  var total = MKDP.state.doc.numPages;
  if (page === total + 1) return [total + 1]; // the back cover, one past the last page
  var left = MKDP.leftOf(page);
  if (left === 1) return [1];
  return left + 1 <= total ? [left, left + 1] : [left];
};
MKDP.viewKind = function (pages) {
  var total = MKDP.state.doc.numPages;
  if (pages.length === 1 && pages[0] === total + 1) return 'backcover';
  if (pages.length === 1 && pages[0] === 1) return 'cover';
  return pages.length === 2 ? 'spread' : 'single';
};
MKDP.cropCanvas = function (bitmap, side) {
  var w = bitmap.width, h = bitmap.height;
  var c = document.createElement('canvas');
  c.width = Math.floor(w / 2);
  c.height = h;
  c.getContext('2d').drawImage(bitmap, side === 'left' ? 0 : Math.floor(w / 2), 0, Math.floor(w / 2), h, 0, 0, Math.floor(w / 2), h);
  return c;
};
MKDP.pageFit = function (page, inPair) {
  var base = page.getViewport({ scale: 1 });
  var stage = MKDP.els.stage;
  var availW = (stage.clientWidth - 24) / (inPair ? 2 : 1);
  var availH = stage.clientHeight - 14;
  var scale = Math.min(availW / base.width, availH / base.height);
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  return { base: base, scale: scale, dpr: dpr };
};
MKDP.getBitmap = function (pageNum) {
  var state = MKDP.state;
  if (state.bitmaps[pageNum]) return Promise.resolve(state.bitmaps[pageNum]);
  return state.doc.getPage(pageNum).then(function (page) {
    var fit = MKDP.pageFit(page, pageNum !== 1);
    var vp = page.getViewport({ scale: fit.scale * fit.dpr });
    var off = document.createElement('canvas');
    off.width = Math.floor(vp.width);
    off.height = Math.floor(vp.height);
    var task = page.render({ canvasContext: off.getContext('2d'), viewport: vp });
    return task.promise.then(function () {
      state.bitmaps[pageNum] = off;
      state.bitmapOrder.push(pageNum);
      while (state.bitmapOrder.length > 10) {
        var evict = state.bitmapOrder.shift();
        if (evict !== pageNum) delete state.bitmaps[evict];
      }
      return off;
    });
  });
};
MKDP.paintInto = function (bitmap, canvas, crop) {
  // crop: null (full bitmap), 'right' (right half), 'left' (left half)
  var w = bitmap.width, h = bitmap.height;
  if (crop) {
    canvas.width = Math.floor(w / 2);
    canvas.height = h;
    canvas.getContext('2d').drawImage(bitmap, crop === 'left' ? 0 : Math.floor(w / 2), 0, Math.floor(w / 2), h, 0, 0, Math.floor(w / 2), h);
  } else {
    canvas.width = w;
    canvas.height = h;
    canvas.getContext('2d').drawImage(bitmap, 0, 0);
  }
};
MKDP.blit = function (bitmap, canvas, crop) {
  MKDP.paintInto(bitmap, canvas, crop === true ? 'right' : crop);
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  canvas.style.width = Math.floor(canvas.width / dpr) + 'px';
  canvas.style.height = Math.floor(canvas.height / dpr) + 'px';
};
MKDP.drawFace = function (face, bitmap, crop) {
  MKDP.paintInto(bitmap, face, crop === true ? 'right' : crop);
};
MKDP.updateChrome = function (pages) {
  var els = MKDP.els, total = MKDP.state.doc.numPages, kind = MKDP.viewKind(pages);
  els.counter.textContent = kind === 'backcover' ? 'Back cover'
    : pages.length === 2
    ? 'Pages ' + pages[0] + '-' + pages[1] + ' of ' + total
    : 'Page ' + pages[0] + ' of ' + total;
  els.prev.disabled = pages[0] <= 1;
  els.next.disabled = kind === 'backcover';
  els.spine.hidden = kind !== 'spread';
  els.spacer.hidden = kind !== 'cover';
  els.canvasL.hidden = kind === 'cover';
  els.canvasR.hidden = kind === 'single' || kind === 'backcover';
  if (kind === 'spread') {
    els.spine.style.height = els.canvasL.style.height;
    els.spine.style.top = els.canvasL.offsetTop + 'px';
  }
  if (kind === 'cover') {
    els.spacer.style.width = els.canvasR.style.width;
    els.spacer.style.height = els.canvasR.style.height;
  }
};
MKDP.renderView = function () {
  var state = MKDP.state, els = MKDP.els;
  if (!state.doc) return Promise.resolve();
  var pages = MKDP.viewPages();
  var kind = MKDP.viewKind(pages);
  var jobs;
  if (kind === 'cover') {
    jobs = [MKDP.getBitmap(1).then(function (bmp) { MKDP.blit(bmp, els.canvasR, true); })];
  } else if (kind === 'backcover') {
    jobs = [MKDP.getBitmap(1).then(function (bmp) { MKDP.blit(bmp, els.canvasL, 'left'); })];
  } else if (kind === 'spread') {
    jobs = [
      MKDP.getBitmap(pages[0]).then(function (bmp) { MKDP.blit(bmp, els.canvasL, false); }),
      MKDP.getBitmap(pages[1]).then(function (bmp) { MKDP.blit(bmp, els.canvasR, false); })
    ];
  } else {
    jobs = [MKDP.getBitmap(pages[0]).then(function (bmp) { MKDP.blit(bmp, els.canvasL, false); })];
  }
  return Promise.all(jobs).then(function () {
    MKDP.updateChrome(pages);
    MKDP.setLoading(false);
    if (els.status) els.status.hidden = true;
    MKDP.scheduleWarm();
  }).catch(function (err) { MKDP.fail(err); });
};
MKDP.scheduleWarm = function () {
  var state = MKDP.state, epoch = state.cacheEpoch;
  setTimeout(function () {
    if (epoch !== state.cacheEpoch || !state.doc || state.animating) return;
    var total = state.doc.numPages, cur = MKDP.leftOf(state.page);
    var targets = [];
    var nl = cur <= 1 ? 2 : cur + 2;
    if (nl <= total) targets.push(nl, nl + 1);
    var pl = cur - 2;
    if (pl >= 2) targets.push(pl, pl + 1);
    if (cur > 1) targets.push(1);
    targets = targets.filter(function (n) { return n >= 1 && n <= total && !state.bitmaps[n]; });
    (function next() {
      if (epoch !== state.cacheEpoch || !targets.length) return;
      MKDP.getBitmap(targets.shift()).then(function () { setTimeout(next, 60); }).catch(function () {});
    })();
  }, 300);
};
MKDP.snapshot = function (canvas) {
  var c = document.createElement('canvas');
  c.width = canvas.width; c.height = canvas.height;
  c.getContext('2d').drawImage(canvas, 0, 0);
  return c;
};
MKDP.rectOf = function (canvas) {
  return { left: canvas.offsetLeft, top: canvas.offsetTop, w: canvas.offsetWidth, h: canvas.offsetHeight };
};
/* Staged flip. NEXT: the sheet is the right page. Its front is the page you
 * are leaving; the new right page is revealed underneath as it lifts; its
 * back is the new left page, which lands on the old left page at the end.
 * PREV mirrors this from the left stack. The untouched side of the base book
 * is never repainted until the sheet has landed. */
MKDP.flipTo = function (targetPage, dir) {
  var state = MKDP.state, els = MKDP.els;
  var reduced = false; /* gate removed 2026-10-23: flip always animates (Fernando's desktop reported reduced-motion and never saw the flip) */
  if (state.animating || reduced || !state.doc) { state.page = targetPage; return MKDP.renderView(); }
  var curPages = MKDP.viewPages(), curKind = MKDP.viewKind(curPages);
  var tgtPages = MKDP.pagesFor(targetPage), tgtKind = MKDP.viewKind(tgtPages);
  var coverFlip = curKind === 'cover' || tgtKind === 'cover' || curKind === 'backcover' || tgtKind === 'backcover';
  if (coverFlip) {
    // 2 pages <-> 1 page: the 3D sheet cannot turn cleanly here (it has to
    // appear or vanish at the spine), so use a short crossfade + slide of
    // the whole book instead. No sheet, no geometry, nothing to misplace.
    state.animating = true;
    var wrapEl = els.wrap;
    wrapEl.style.transition = 'opacity 150ms ease, transform 150ms ease';
    wrapEl.style.opacity = '0';
    wrapEl.style.transform = 'translateX(' + (dir > 0 ? -16 : 16) + 'px)';
    setTimeout(function () {
      state.page = targetPage;
      MKDP.renderView().then(function () {
        wrapEl.style.transition = 'opacity 190ms ease, transform 190ms ease';
        wrapEl.style.opacity = '1';
        MKDP.applyTransform();
        setTimeout(function () { wrapEl.style.transition = ''; state.animating = false; }, 200);
      });
    }, 160);
    return;
  }
  var flipMs = 550;
  var flipEase = 'cubic-bezier(.3,.6,.3,1)';
  var leaf = els.leaf;
  state.animating = true;
  var watchdog = setTimeout(function () {
    state.animating = false;
    leaf.hidden = true;
    if (els.flipshadow) els.flipshadow.hidden = true;
  }, 1500);
  function finish() {
    clearTimeout(watchdog);
    leaf.hidden = true;
    leaf.style.transition = 'none';
    if (els.flipshadow) {
      els.flipshadow.hidden = true;
      if (state.shadowAnim) { state.shadowAnim.cancel(); state.shadowAnim = null; }
    }
    state.page = targetPage;
    state.animating = false;
    MKDP.renderView();
  }
  try {
    var need = [];
    if (dir > 0) {
      if (tgtKind === 'backcover') need = [1];
      else if (tgtKind === 'spread') need = [tgtPages[0], tgtPages[1]];
      else if (tgtKind === 'single') need = [tgtPages[0]];
    } else {
      need = tgtKind === 'cover' ? [1] : [tgtPages[0], tgtPages[1]];
    }
    Promise.all(need.map(function (n) { return MKDP.getBitmap(n); })).then(function (bmps) {
      var bmpOf = {};
      need.forEach(function (n, i) { bmpOf[n] = bmps[i]; });
      var frontBmp, backBmp, frontCrop = false, backCrop = false, rect, origin, fromDeg, toDeg;
      var staged = null; // base-page changes, applied in the same frame as the sheet
      function placeLeaf() {
        MKDP.drawFace(els.leafFront, frontBmp, frontCrop);
        MKDP.drawFace(els.leafBack, backBmp, backCrop);
        leaf.style.left = rect.left + 'px';
        leaf.style.top = rect.top + 'px';
        leaf.style.width = rect.w + 'px';
        leaf.style.height = rect.h + 'px';
        leaf.style.transformOrigin = origin;
        if (staged) staged();
        leaf.hidden = false;
        leaf.style.transition = 'none';
        leaf.style.transform = 'rotateY(' + fromDeg + 'deg)';
        void leaf.offsetWidth;
        if (els.flipshadow) {
          try {
            var sh = els.flipshadow;
            var shLeft = dir > 0 ? rect.left - rect.w : (tgtKind === 'cover' ? rect.left : rect.left + rect.w);
            sh.style.left = shLeft + 'px';
            sh.style.top = rect.top + 'px';
            sh.style.width = rect.w + 'px';
            sh.style.height = rect.h + 'px';
            sh.style.background = dir > 0
              ? 'linear-gradient(to left, rgba(46,26,56,.30), rgba(46,26,56,0) 72%)'
              : 'linear-gradient(to right, rgba(46,26,56,.30), rgba(46,26,56,0) 72%)';
            sh.hidden = false;
            state.shadowAnim = sh.animate(
              [{ opacity: 0 }, { opacity: 1, offset: 0.45 }, { opacity: 0 }],
              { duration: flipMs, easing: 'ease-in-out' });
          } catch (e) { /* shadow is decoration only */ }
        }
        leaf.style.transition = 'transform ' + (flipMs / 1000) + 's ' + flipEase;
        leaf.style.transform = 'rotateY(' + toDeg + 'deg)';
        setTimeout(finish, flipMs + 50);
      }
      if (dir > 0) {
        var curRightNum = curKind === 'cover' ? 1 : curPages[curPages.length - 1];
        MKDP.getBitmap(curRightNum).then(function (curBmp) {
          frontBmp = curBmp; frontCrop = curKind === 'cover';
          if (tgtKind === 'backcover') { backBmp = bmpOf[1]; backCrop = 'left'; }
          else backBmp = bmpOf[tgtPages[0]];
          rect = MKDP.rectOf(curKind === 'single' ? els.canvasL : els.canvasR);
          origin = 'left center'; fromDeg = 0; toDeg = -180;
          // revealed side: the new right page under the lifting sheet; when
          // closing the book, the right side simply empties under the sheet
          staged = function () {
            if (tgtKind === 'spread') MKDP.blit(bmpOf[tgtPages[1]], els.canvasR, false);
            if (tgtKind === 'backcover') { els.canvasR.hidden = true; els.spine.hidden = true; }
          };
          placeLeaf();
        }).catch(function () { finish(); });
      } else if (tgtKind === 'cover') {
        MKDP.getBitmap(curPages[0]).then(function (curLeftBmp) {
          // Same motion as every other Back flip: the sheet starts flat on
          // the left (front = the old left page), turns around the spine,
          // and lands on the right showing its back = the front cover.
          frontBmp = curLeftBmp;
          backBmp = bmpOf[1]; backCrop = true;
          rect = MKDP.rectOf(els.canvasL);
          origin = 'right center'; fromDeg = 0; toDeg = 180;
          // revealed side: the left closes to blank under the lifting sheet
          staged = function () {
            els.canvasL.hidden = true;
            els.spacer.hidden = false;
            els.spacer.style.width = els.canvasR.style.width;
            els.spacer.style.height = els.canvasR.style.height;
            els.spine.hidden = true;
          };
          placeLeaf();
        }).catch(function () { finish(); });
      } else {
        var curBmpPromise = curKind === 'backcover'
          ? MKDP.getBitmap(1).then(function (b) { return MKDP.cropCanvas(b, 'left'); })
          : MKDP.getBitmap(curPages[0]);
        curBmpPromise.then(function (curLeftBmp) {
          // The sheet starts flat on the left: its front (facing up) is the
          // old left page (or the back cover). It rotates around the spine
          // (its right edge) and lands on the right as the new right page.
          frontBmp = curLeftBmp;
          backBmp = bmpOf[tgtPages[1]];
          rect = MKDP.rectOf(els.canvasL);
          origin = 'right center'; fromDeg = 0; toDeg = 180;
          // revealed side: the new left page under the lifting sheet
          staged = function () { MKDP.blit(bmpOf[tgtPages[0]], els.canvasL, false); };
          placeLeaf();
        }).catch(function () { finish(); });
      }
    }).catch(function () { finish(); });
  } catch (e) {
    finish();
  }
};
MKDP.step = function (dir) {
  var state = MKDP.state;
  if (!state.doc || state.animating) return;
  var total = state.doc.numPages, target;
  if (dir > 0) target = state.page <= 1 ? 2 : MKDP.leftOf(state.page) + 2;
  else target = state.page <= 2 ? 1 : MKDP.leftOf(state.page) - 2;
  if (state.page === 3 && dir < 0) target = 1;
  target = Math.max(1, Math.min(total + 1, target));
  if (target === state.page) return;
  MKDP.resetZoom();
  MKDP.flipTo(target, dir);
};
MKDP.renderPage = function () { return MKDP.renderView(); };
